import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "token", "submit", "error"]
  static values = { publicKey: String, amount: Number, customer: Object }

  async connect() {
    if (!window.AbacatePay) return this.fail("Não conseguimos carregar o formulário do cartão. Recarregue a página.")

    this.checkout = window.AbacatePay.create({
      publicKey: this.publicKeyValue,
      amount: this.amountValue,
      onCardChange: ({ canTokenize }) => { this.submitTarget.disabled = !canTokenize }
    })
    try {
      await this.checkout.mount(this.cardTarget)
    } catch {
      this.fail("Não conseguimos carregar o formulário do cartão. Recarregue a página.")
    }
  }

  disconnect() {
    this.checkout?.destroy()
  }

  async submit(event) {
    if (this.tokenTarget.value) return

    event.preventDefault()
    this.submitTarget.disabled = true
    try {
      const { token } = await this.checkout.tokenize(this.customerValue)
      this.tokenTarget.value = token
      this.element.requestSubmit()
    } catch {
      this.submitTarget.disabled = false
      this.fail("Confira os dados do cartão e tente de novo.")
    }
  }

  fail(message) {
    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }
}
